import { steps } from "@/mocks/home";

export default function Process() {
  return (
    <section
      id="process"
      className="relative py-24 md:py-32 bg-foreground-950 overflow-hidden"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dark%20burgundy%20wine%20red%20gradient%20texture%20background%20with%20subtle%20film%20grain%20and%20soft%20paper%20texture%2C%20cinematic%20moody%20atmosphere%2C%20refined%20editorial%20photography%20aesthetic%2C%20premium%20luxury%20dark%20atmosphere%2C%20deep%20wine%20red%20and%20dark%20charcoal%20tones&width=1800&height=900&seq=dada-process-bg-01&orientation=landscape"
        alt="dark burgundy gradient"
        className="absolute inset-0 w-full h-full object-cover opacity-25"
      />
      <div className="absolute inset-0" style={{ backgroundColor: 'rgba(56, 56, 56, 0.7)' }}></div>
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <div className="text-primary-400 text-xs tracking-[0.32em] font-semibold mb-4">
            HOW WE DO
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-background-50 leading-tight">
            <span className="md:inline block">의뢰부터 지급까지, </span>
            <span className="md:inline block">
              <span className="text-primary-400">여섯 단계</span>
              <span>로</span>
            </span>
            <span className="md:inline block">완결합니다</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map((s) => (
            <div
              key={s.step}
              className="relative bg-background-50/5 border border-background-50/15 backdrop-blur rounded-lg p-8 hover:bg-background-50/10 transition"
            >
              <div className="flex items-center justify-between mb-6">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className={`${s.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-4xl font-bold text-background-50/20">
                  {s.step}
                </span>
              </div>
              <div className="font-heading text-xl font-bold text-background-50">
                {s.ttl}
              </div>
              <p className="mt-3 text-sm text-background-200 leading-relaxed">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}